import React, { useEffect, useState } from 'react';
import RadioList, { FilterListItem } from '../RadioList';
import { companyService } from '../../../services/central-api/company';
import { FieldValues, Path } from 'react-hook-form';
import { useCurrentApp } from '../../../context/CurrentApp';

function CompanyList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const { isParentApp } = useCurrentApp();

    async function getCompanies() {
        try {
            setIsLoading(true);
            const companies = await companyService.getSimplifiedCompanies();
            setItems(companies.map((company) => {
                return {
                    value: company.id,
                    label: company.name
                };
            }));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (isParentApp) {
            getCompanies();
        }
    }, []);

    return <RadioList items={items} name={name} clearValue={null} isLoading={isLoading} />;
}

CompanyList.getCount = RadioList.getCount;

export default CompanyList;
